<script>
// import IconList from '@img/icons/lucide/list.svg?inline';
// import IconHistory from '@img/icons/lucide/history.svg?inline';
import UiTabs from '~/components/UiTabs.vue';
import Details from './Tabs/Details.vue';
import EventOverview from './Tabs/EventOverview.vue';
import ValueFlow from './Tabs/ValueFlow.vue';

// The tab replays the trace in an emulator: nothing of it loads until it is opened.
const StateChanges = () => import(/* webpackChunkName: "tx-state-changes" */ './Tabs/StateChanges.vue');

export default {
    props: {
        traceId: {
            type: String,
            default: null,
        },
        timeStart: {
            type: Number,
            default: null,
        },
        traceActions: {
            type: [Array, undefined],
            default: undefined,
        },
        trace: Object,
        traceEmpty: Boolean,
        isTickTock: Boolean,
        duration: [String, Number],
        warning: Boolean,
        isLargeTrace: Boolean,
        hasMoreActions: Boolean,
        isLoadingMoreActions: Boolean,
        // Everything the value flow reads: the trace transactions keyed by
        // hash, plus the address book and jetton metadata that came with them.
        traceTransactions: Object,
        traceAddressBook: Object,
        traceMetadata: Object,
    },

    computed: {
        tabs() {
            return [{
                key: 'overview',
                text: this.$t('transactionPage.overview'),
                content: {
                    props: {
                        traceActions: this.traceActions,
                        traceEmpty: this.traceEmpty,
                        trace: this.trace,
                        isTickTock: this.isTickTock,
                        warning: this.warning,
                        isLargeTrace: this.isLargeTrace,
                        hasMoreActions: this.hasMoreActions,
                        isLoadingMoreActions: this.isLoadingMoreActions,
                    },
                    eager: true,
                    component: EventOverview,
                },
            }, {
                key: 'value_flow',
                text: this.$t('transactionPage.value_flow'),
                content: {
                    props: {
                        transactions: this.traceTransactions,
                        actions: this.traceActions,
                        addressBook: this.traceAddressBook,
                        metadata: this.traceMetadata,
                        isLargeTrace: this.isLargeTrace,
                        warning: this.warning,
                    },
                    component: ValueFlow,
                },
            }, {
                key: 'state_changes',
                text: this.$t('transactionPage.state_changes'),
                content: {
                    props: {
                        transactions: this.traceTransactions,
                        addressBook: this.traceAddressBook,
                        isLargeTrace: this.isLargeTrace,
                        warning: this.warning,
                    },
                    component: StateChanges,
                },
            }, {
                key: 'details',
                text: this.$t('transactionPage.details'),
                content: {
                    props: {
                        traceId: this.traceId,
                        timeStart: this.timeStart,
                        duration: this.duration,
                    },
                    eager: true,
                    component: Details,
                },
            }];
        },
    },

    render(createComponent) {
        return createComponent(UiTabs, {
            class: 'card card--tabbed tx-tabs-items-pd',
            props: {
                tabs: this.tabs,
                changeUrlHash: true,
            },
            on: this.$listeners,
            scopedSlots: this.$scopedSlots,
        });
    },

    components: {
        UiTabs,
        // Details,
        // IconList,
    },
};
</script>
